import { useEffect, useState } from "react";
import { FormLabel, FormControl, InputGroup, Text } from "@chakra-ui/react";
import ReactSelect from "react-select";

const FormikSearchAbleSelect = ({
  formik,
  label,
  name = "",
  placeholder,
  labelColor,
  labelSize,
  style,
  children,
  onSelectChange,
  isArray = false,
  index = 0,
  field = "",
  disabled = false,
}) => {
  const [selectedValue, setSelectedValue] = useState();

  const onChangeHandler = (option) => {
    setSelectedValue(option);
    if (isArray) {
      formik.setFieldValue(`${name}.${index}.${field}`, option.label);
    } else {
      formik.setValues({
        ...formik.values,
        [name]: option?.value,
      });
    }
    if (onSelectChange) {
      onSelectChange(option);
    }
  };

  useEffect(() => {
    if (isArray) {
      const labels = children?.find(
        (child) => child?.props?.children === formik.values[name][index][field]
      );
      setSelectedValue({
        value: labels?.props?.value,
        label: labels?.props?.children,
      });
    } else {
      const label = children?.find(
        (child) => child?.props?.value === formik.values[name]
      );
      setSelectedValue({
        value: label?.props?.value,
        label: label?.props?.children,
      });
    }
  }, [children]);

  return (
    <FormControl style={style}>
      <FormLabel
        color={labelColor ? labelColor : "#000000"}
        marginBottom={2}
        fontFamily={"PlusJakartaSansMedium"}
        fontSize={labelSize ? labelSize : "12px"}
        lineHeight={"16px"}
        textTransform={"capitalize"}
      >
        {label}
      </FormLabel>
      <InputGroup>
        <ReactSelect
          isClearable
          value={selectedValue}
          placeholder={placeholder}
          onChange={onChangeHandler}
          bg={"white"}
          fontFamily={"PlusJakartaSansMedium"}
          borderRadius={4}
          fontSize={"12px"}
          height={"48px"}
          options={children?.map((child) => {
            return {
              value: child?.props.value,
              label: child?.props.children,
            };
          })}
          menuPortalTarget={document.body}
          styles={{
            container: (styles) => ({ ...styles, width: "100%" }),
            control: (styles) => ({
              ...styles,
              borderColor: "#E2E2E2",
              borderRadius: 4,
              paddingBlock: 5,
            }),
            menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
          }}
          isDisabled={disabled}
        />
      </InputGroup>
      {formik.touched[name] && formik.errors[name] ? (
        <Text color="#800" fontSize="10px">
          {formik.errors[name]}
        </Text>
      ) : null}
    </FormControl>
  );
};

export default FormikSearchAbleSelect;
